import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'appSenace';
  // mostrar = true;

  constructor(private router: Router, private aRouter: ActivatedRoute) {
    // this.router.events.pipe(filter(e => e instanceof NavigationEnd))
    //   .subscribe((s: NavigationEnd) => {
    //     if(s.url.indexOf('/g/')>=0){
    //       this.mostrar = false;
    //     }
    //   });
  }
}
